import { render, staticRenderFns } from "./FormasPagamento.vue?vue&type=template&id=d484200c&scoped=true&"
import script from "./FormasPagamento.vue?vue&type=script&lang=js&"
export * from "./FormasPagamento.vue?vue&type=script&lang=js&"
import style0 from "./FormasPagamento.vue?vue&type=style&index=0&id=d484200c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d484200c",
  null
  
)

export default component.exports